import React, { createContext, useContext, useEffect, useState } from "react";
import { getContent } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/content";

const ContentContext = createContext(DEFAULT_CONTENT);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  useEffect(() => {
    getContent()
      .then((data) => setContent({ ...DEFAULT_CONTENT, ...data }))
      .catch(() => {});
  }, []);
  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
